import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from '../queries/queryKeys';

const deleteRSODraft = async (draftId) => {
  const res = await request.delete(
    `/Meter/rso_delete_draft?draftId=${draftId}`,
    null,
    'Не получилось удалить отчет РСО',
    null,
    null
  );

  return res;
};

const useDeleteRSODraft = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(deleteRSODraft, {
    onSuccess: () => {
      queryClient.removeQueries(getQueryKeys.rsoDraft());
    },
  });

  return {
    deleteRso: mutation.mutateAsync,
    loading: mutation.isLoading,
  };
};

export default useDeleteRSODraft;
